import { render, staticRenderFns } from "./quotes-block.vue?vue&type=template&id=6eb9d2c2&scoped=true"
var script = {}
import style0 from "./quotes-block.vue?vue&type=style&index=0&id=6eb9d2c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb9d2c2",
  null
  
)

export default component.exports